import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import "bootstrap/dist/css/bootstrap.min.css";
import "./css/font.css";
import "./css/component.css"
import "./css/table.css"
import { AuthProvider } from './contexts/AuthContext';
import { PageProvider } from './contexts/PageContext';
import { SettingProvider } from './contexts/SettingContext';
import { AdminProvider } from './contexts/AdminContext';

const root = ReactDOM.createRoot(document.getElementById('main-root'));
document.body.style.backgroundColor = "#f5f5f5";
root.render(
  <React.StrictMode>
    
    <AuthProvider><PageProvider><SettingProvider><AdminProvider>
      <App />
    </AdminProvider></SettingProvider></PageProvider></AuthProvider>
    
  </React.StrictMode>
);